import {config} from "@/constants/config";
import type {TResponseRequest} from "@/interfaces/http.interface";
import httpRequest from "@/providers/http/request.http";
import {buildQueryUrl} from "@/providers/http/request.instance";
import {type PaginatedResult, normalizePagination} from "@/utils/pagination";

export interface ExchangeRate {
  id: string;
  from_currency: string;
  to_currency: string;
  buy_rate: string;
  sell_rate: string;
  spread_pct: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

interface ExchangeRateFilters {
  limit?: number;
  offset?: number;
}

export type ExchangeRateListResult = PaginatedResult<ExchangeRate>;

export const getExchangeRatesService = async (
  filters: ExchangeRateFilters = {}
): Promise<TResponseRequest<ExchangeRateListResult>> => {
  const raw = await httpRequest.get<ExchangeRate[]>({
    url: buildQueryUrl(`${config.walletApiUrl}/bo/exchange-rates`, filters as Record<string, unknown>),
  });
  if (!raw.data || !raw.pagination) return {...raw, data: undefined};
  return {...raw, data: {items: raw.data, pagination: normalizePagination(raw.pagination)}};
};

export const createExchangeRateService = async (body: {
  from_currency: string;
  to_currency: string;
  buy_rate: string;
  sell_rate: string;
}): Promise<TResponseRequest<ExchangeRate>> => {
  return httpRequest.post<ExchangeRate>({
    url: `${config.walletApiUrl}/bo/exchange-rates`,
    body,
  });
};

export const updateExchangeRateService = async (
  id: string,
  body: Partial<{
    buy_rate: string;
    sell_rate: string;
    is_active: boolean;
  }>
): Promise<TResponseRequest<ExchangeRate>> => {
  return httpRequest.put<ExchangeRate>({
    url: `${config.walletApiUrl}/bo/exchange-rates/${encodeURIComponent(id)}`,
    body,
  });
};

export const deleteExchangeRateService = async (id: string): Promise<TResponseRequest<void>> => {
  return httpRequest.delete<void>({
    url: `${config.walletApiUrl}/bo/exchange-rates/${encodeURIComponent(id)}`,
    body: {},
  });
};
